import { useEffect, useRef } from 'react';

class PollingHandler {
  isActive: boolean;
  pollingTimeout: NodeJS.Timeout | null;

  constructor() {
    this.isActive = false;
    this.pollingTimeout = null;

    this.startPolling = this.startPolling.bind(this);
    this.stopPolling = this.stopPolling.bind(this);
    this.clearPollingTimeout = this.clearPollingTimeout.bind(this);
  }

  async startPolling(execFunction: () => Promise<void>, interval = 2000) {
    this.isActive = true;
    this.clearPollingTimeout();

    try {
      await execFunction();
      const _this = this;
      this.pollingTimeout = setTimeout(async () => {
        if (_this.isActive) {
          await _this.startPolling(execFunction, interval);
        }
      }, interval);
    } catch (error) {
      this.stopPolling();
    }
  }

  stopPolling() {
    this.isActive = false;
    this.clearPollingTimeout();
  }

  clearPollingTimeout() {
    if (this.pollingTimeout) {
      clearInterval(this.pollingTimeout);
      this.pollingTimeout = null;
    }
  }
}

export const usePolling = () => {
  const pollingHandler = useRef<PollingHandler>(new PollingHandler());
  useEffect(() => {
    return () => {
      pollingHandler.current.stopPolling();
    };
  }, []);

  return {
    startPolling: pollingHandler.current.startPolling,
    stopPolling: pollingHandler.current.stopPolling,
  };
};
